exports.components = {
  "component---src-pages-arti-js": () => import("./../../../src/pages/arti.js" /* webpackChunkName: "component---src-pages-arti-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-shallow-green-js": () => import("./../../../src/pages/projects/shallow-green.js" /* webpackChunkName: "component---src-pages-projects-shallow-green-js" */)
}

